module.exports = __webpack_public_path__ + "static/media/medical_care.abca6eee.svg";